"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlight = exports.highlighter = void 0;
var react_1 = __importDefault(require("react"));
var theme_1 = require("../../../mantine-theme/src");
var Text_1 = require("../Text/Text");
function highlighter(value, highlightPart) {
    var normalizedValue = value.trim().toLowerCase();
    var normalizedHighlight = highlightPart.trim().toLowerCase();
    var diff = highlightPart.length - normalizedHighlight.length;
    var highlightLength = highlightPart.length - diff;
    var highlightIndex = normalizedValue.indexOf(normalizedHighlight);
    if (highlightIndex === -1) {
        return { start: value, highlighted: '', end: '' };
    }
    var start = value.slice(0, highlightIndex);
    var highlighted = value.slice(highlightIndex, highlightIndex + highlightLength);
    var end = value.slice(highlightIndex + highlightLength);
    return { start: start, highlighted: highlighted, end: end };
}
exports.highlighter = highlighter;
function Highlight(_a) {
    var children = _a.children, highlight = _a.highlight, component = _a.component, themeOverride = _a.themeOverride, _b = _a.highlightColor, highlightColor = _b === void 0 ? 'yellow' : _b, others = __rest(_a, ["children", "highlight", "component", "themeOverride", "highlightColor"]);
    var theme = theme_1.useMantineTheme(themeOverride);
    var color = theme_1.getThemeColor({
        theme: theme,
        color: highlightColor,
        shade: 2,
    });
    var _c = highlighter(children, highlight), start = _c.start, end = _c.end, highlighted = _c.highlighted;
    return (react_1.default.createElement(Text_1.Text, __assign({ component: component, themeOverride: themeOverride }, others),
        !!start && start,
        !!highlighted && (react_1.default.createElement("mark", { style: {
                backgroundColor: color,
                color: theme.colorScheme === 'dark' ? theme.colors.dark[9] : 'inherit',
            } }, highlighted)),
        !!end && end));
}
exports.Highlight = Highlight;
Highlight.displayName = '@mantine/core/Highlight';
